import React from 'react'
import { TFunction } from 'i18next'
import { RECURRENCE_OPTIONS } from './recurrencePure'

export * from './recurrencePure'

export interface MenuItemProps {
  key: string
  label: React.ReactNode
  onClick: (e: { domEvent?: Event }) => void
}

/**
 * Recurrence dropdown menu items
 *  - never
 *  - daily
 *  - weekly
 *  - biweekly
 *  - monthly
 *  - 3monthly
 *  - 6monthly
 *  - yearly
 *  - custom
 */
export const getRecurrenceDropDownMenuItems = (
  t: TFunction,
  styles: Record<string, string>,
  onItemClick: (key: string) => void,
): MenuItemProps[] => {
  return RECURRENCE_OPTIONS.map((option) => ({
    key: option.key,
    label: (
      <div className={styles.subRecurrenceMenuItem}>
        <span>{t(option.label) /* i18next-extract-disable-line */}</span>
      </div>
    ),
    onClick: (e: { domEvent?: Event }) => {
      e.domEvent?.stopPropagation()
      onItemClick(option.key)
    },
  }))
}
